import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DevMenu from './components/DevMenu';
import Base from './pages/Base';
import Redirects from './pages/Redirects';
import isNonProduction from './utilities/isNonProduction';
import ScrollToTop from './utilities/ScrollToTop';

const devMenu = process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_MOCK_API === 'true' && <DevMenu />;

ReactGA.initialize('G-GMR43SBE9K');

// localStorage keys for dev-only theme controls.
export const DEV_TENANT_OVERRIDE_KEY = 'dev_tenantIdOverride';
export const DEV_THEME_MODE_KEY = 'dev_themeMode';

const App = (): JSX.Element => {
  const [themeMode, setThemeMode] = useState<'light' | 'dark'>(() =>
    localStorage.getItem(DEV_THEME_MODE_KEY) === 'dark' ? 'dark' : 'light'
  );
  // The tenant theme override is a dev-only affordance: in production it is
  // pinned to 0 (no override) so a stray localStorage value can never re-brand a
  // real customer's invoice. The override UI is also hidden in prod (DevelopmentInfo).
  const [tenantIdOverride, setTenantIdOverride] = useState<number>(() =>
    isNonProduction ? Number(localStorage.getItem(DEV_TENANT_OVERRIDE_KEY)) || 0 : 0
  );

  useEffect(() => {
    localStorage.setItem(DEV_THEME_MODE_KEY, themeMode);
  }, [themeMode]);

  useEffect(() => {
    if (isNonProduction) {
      localStorage.setItem(DEV_TENANT_OVERRIDE_KEY, String(tenantIdOverride));
    }
  }, [tenantIdOverride]);

  const devProps = {
    themeMode,
    onThemeModeChange: setThemeMode,
    tenantIdOverride,
    onTenantOverrideChange: setTenantIdOverride,
  };

  return (
    <Grid container className="container-fluid wrapper">
      <Grid item xs={12} justifyItems="center" alignItems="center">
        <BrowserRouter>
          <ScrollToTop />
          {devMenu}
          <Routes>
            <Route
              path="/invoice/:invoiceId"
              element={<Base page="Summary" {...devProps} />}
            />
            <Route
              path="/invoice/:invoiceId/address"
              element={<Base page="Billing" {...devProps} />}
            />
            <Route
              path="/invoice/:invoiceId/pay"
              element={<Base page="Payment" {...devProps} />}
            />
            <Route
              path="/invoice/:invoiceId/confirmation"
              element={<Base page="Confirmation" {...devProps} />}
            />
            <Route path="/invoice/:invoiceId/*" element={<Redirects />} />
            <Route path="*" element={<Redirects />} />
          </Routes>
        </BrowserRouter>
      </Grid>
    </Grid>
  );
};

export default App;
